// extracted by mini-css-extract-plugin
module.exports = {"filters":"FiltersBar_filters__1yRLu"};